export const AlignmentCoverageEndpoints = {
  coverageInformation: (serviceProviderId: string) =>
    `/alignment/coverage-information/${serviceProviderId}`,
  coverageCities: "/alignment/coverage-cities",
  coverageCityStates: (serviceProviderId: string) =>
    `/alignment/coverage-cities/${serviceProviderId}`,
} as const;

